import { Navigate } from 'react-router-dom';
import { useSelector } from 'react-redux';

export { Home };

function Home() {
    const auth = useSelector(x => x.auth.value);

    switch (auth.role){
        case ("user_geolocalisation"):
            return <Navigate to="/geolocalisation" />;
        case ("admin"):
        case ("user_portal"):
            return <Navigate to="/donnees" />;
        default:
            return <Navigate to="/geolocalisation" />;
    }
}